@import '~style-sheet-helpers/core.less';

@modal-padding: 16px;
@column-width: calc(50% - 20px);

.address-header {
  margin: 16px 0 0;
  line-height: 20px;
}

.time-zone {
  display: block;

  .time-zone-label {
    font-weight: 400;
    font-size: 12px;
  }
}

.checkbox {
  margin: 8px 0;
  font-size: 14px;
  line-height: 20px;
}

.default-location {
  margin-top: 28px;
}
